var modules_a2a4272b = {"container":"Sorter_module_container__04ae5f19","icon-sort":"Sorter_module_iconSort__04ae5f19","sort-asc":"Sorter_module_sortAsc__04ae5f19","sort-desc":"Sorter_module_sortDesc__04ae5f19","fill":"Sorter_module_fill__04ae5f19"};
import "../../../assets/esm/components/Table/src/Sorter~Bmt21H4j.css";

export { modules_a2a4272b as default };
//# sourceMappingURL=Sorter.module.less.js.map
